// polyfill promise in older browsers and https://caniuse.com/mdn-javascript_builtins_promise_withresolvers
import 'core-js/features/promise'
import 'react-datepicker/dist/react-datepicker.css'
import './assets/css/react-select.css'
import './assets/css/style.css'

import { hu } from 'date-fns/locale'
import moment from 'moment'
import huLocalization from 'moment/dist/locale/hu'
import { registerLocale } from 'react-datepicker'
import { createRoot } from 'react-dom/client'
import TagManager from 'react-gtm-module'

import { APP_NAME, initSentry, startVersionWatch } from '@libs/typescript-utils'

import App from '@oldComponents/App'

moment.updateLocale('hu', huLocalization)

registerLocale('hu', hu)

initSentry({
  sentryDsn: window.sentryDsn,
  appVersion: window.appVersion,
  appEnv: window.appEnv,
  sentryTracesSampleRate: window.sentryTracesSampleRate,
  sentryReplaysSessionSampleRate: window.sentryReplaysSessionSampleRate,
  sentryReplaysOnErrorSampleRate: window.sentryReplaysOnErrorSampleRate,
})

if (window.gtmId) {
  TagManager.initialize({ gtmId: window.gtmId })
}

startVersionWatch(APP_NAME.TMS)

const container = document.getElementById('root')

// We know that the root element exists
const root = createRoot(container!)
root.render(<App />)
